import React, { useContext, useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Observer, observer } from 'mobx-react-lite';

import Navbar from './components/Navbar/Navbar';
import Footer from "./components/Footer/Footer"
import PageInformation from "./Pages/PageInformation/PageInformation"
import EnterRoom from './Pages/Free_rooms/enter_room';
import RoomList from './Pages/Money_rooms/RoomList';
import PrivateRoute from './PrivateRoute';
import Settings from './Pages/Settings/settings'
import Main from "./Pages/MainPage/Main"
import "./vars_main.css"
import RoomService from "./service/RoomService"
import GoogleAuth from "./Helpers/GoogleAuth"
import Deposit from "./Pages/Payments/deposit"
import Information from "./components/UI/Notification/Information"
import msgpack from 'msgpack-lite';
import BotsFight from "./Pages/Roulete_snakes/BotsFight";
import PageGameSlot from "./Pages/SlotsIgrator/components/pageGame/pageGameSlot";
import Winner from "./components/UI/Winner/Winner";
import "./fonts_main.css"
import TableBets from "./components/UI/TableBets";
import { Context } from "./index";
import SimpleRoulete from "./Pages/Wheel/SimpleRoulete";
import { Plinko } from "./Pages/Plinko/Plinko";
import MainPageSlots from "./Pages/SlotsIgrator/components/MainPage/MainPageSlots";
import Dropdown_languages from "./components/UI/Dropdown_languages";
import vibrateFunc from "./Utils/vibrateFunc";
import { useVibrate } from 'react-use';
import Testik from "./Testik";
import styles from "./Main.module.css"
import SuccsesFreeSpins from "./components/Modals/components/SuccsesFreeSpins/SuccsesFreeSpins";
import Modal from "./components/Modals/Modal";
import Promocode from "./components/Modals/components/Promocode/Promocode";
import modal from "./components/Modals/Modal";
import LoginForm from "./Pages/LoginForm/LoginForm";
import RegForm from "./Pages/RegForm/RegForm";
import RightBar from './components/RightBar/RightBar';
import { mainSchema, WS_MAIN, WS_ROULETE } from './Utils/NAME_HOST';
import Auction from './Pages/Auction/Auction';
import { unpack } from './Utils/forSocket';
import Sapper from './Pages/Sapper/Sapper';
import InfoTour from './Pages/Tournaments/components/InfoTour/InfoTour';
import Tournaments from './Pages/Tournaments/Tournaments';
import PageTour from './Pages/Tournaments/components/PageTour/PageTour';
import TelegramAuth from './Pages/TelegramAuth/TelegramAuth';

const MainApp = observer(() => {
    const { store } = useContext(Context)
    const [message, setMessage] = useState("")
    const [timeRemaining, setInitialTime] = useState(0)
    const [event_onClick, setEvent_onClick] = useState(false)
    const [modal_freespins, setModal_freespins] = useState({ status: false, freespins: 0 })
    const [modal_promocode, setModal_promocode] = useState({ status: false })
    const [modal_unReg, setModal_unReg] = useState({ status: false })
    const [modal_Login, setModal_Login] = useState({ status: false })
    const [modelState, setModelState] = useState({})

    const [current_url, setCurrentUrl] = useState("")
    const [isVibrating, setIsVibrating] = useState(false);
    



    // Пример асинхронной функции
    async function exampleAsyncFunction() {
        try {
            //console.log("Начало выполнения асинхронной функции");

            // Имитация асинхронной операции (например, запрос к серверу)
            const result = await someAsyncOperation();

            //console.log("Результат асинхронной операции:", result);

            // Другие асинхронные операции
            const additionalResult = await anotherAsyncOperation();

            //console.log("Дополнительный результат:", additionalResult);

            //console.log("Завершение выполнения асинхронной функции");
        } catch (error) {
            console.error(error);
        }
    }

    // Функция, имитирующая асинхронную операцию (например, запрос к серверу)
    function someAsyncOperation() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                // Имитация успешного завершения асинхронной операции
                resolve("Успешный результат");
                // Имитация ошибки в асинхронной операции
                // reject(new Error("Ошибка в асинхронной операции"));
            }, 2000); // Имитация задержки
        });
    }

    // Другая функция, также имитирующая асинхронную операцию
    function anotherAsyncOperation() {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve("Дополнительный результат");
            }, 1000);
        });
    }

    // Вызов асинхронной функции

    const formatTime = (time) => {
        const hours = Math.floor(time / 3600);
        const minutes = Math.floor((time % 3600) / 60);
        const seconds = time % 60;

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };
    const getServerTime = async () => {
        try {

            const time_response = await RoomService.getTimeTour();
            if (time_response.data) {
                // //console.log(time_response.data)
                setInitialTime(time_response.data.initialTime + 3600)
                // setInitialTimeReg(time_response.data.initialTimeReg)
            }

        } catch (e) {
            //console.log(e)
        }


    }


    

    useEffect(() => {
        const socket = new WebSocket(WS_MAIN);
        socket.binaryType = "arraybuffer"
        store.set_socket(socket)
    }, [])
    useEffect(() => {
        if (!store.isLoadingComponent && !event_onClick) {
            // setTimeout(() => {

            const buttons = document.querySelectorAll("button")
            //console.log(buttons)
            for (const button of buttons) {
                button.addEventListener('click', () => {
                    //navigator.vibrate([200, 100, 200]); // Вибрация: 200мс вибрация, 100мс пауза, 200мс вибрация
                });

            }


            // }, 1000)
            setEvent_onClick(true)

        }

    }, [store.isLoadingComponent])
    async function listenSocket() {
        const socket = store.socket;


        socket.addEventListener('message', async (eventClient) => {
            const dataClient = mainSchema.decode(eventClient.data)

            // const dataClient = this.unpack(eventClient.data);
            const event = dataClient.event;
            let data = dataClient.data;
            if (dataClient.event.length > 1) {
                data = unpack(data);
            }
            
            if (event === "ChangeSecondAuction"){
                store.set_time_auction(data);
            }
            

        })
    }
    useEffect(()=>{
        if (store.state_socket === "open"){
            listenSocket()

            

        }
    },[store.state_socket])
    useEffect(() => {
        const data = store.get_modal()
        
        //console.log(data,"data")
        if (data) {
            if (data.type === "freespins") {
                setModal_freespins({ status: true, freespins: data.freespins, text: data.text })
            }

            if (data.type === "promocode") {
                setModal_promocode({ status: true })
            }
            if (data.type === "login"){
                setModal_Login({ status: true })

            }
            if (data === "unreg") {
                setModal_unReg({ status: true })
            }
            store.set_modal(null)
        }
    }, [store.modal]);


    useEffect(() => {
        if (timeRemaining > 0 && timeRemaining < 3600 * 1.5 && window.location.href !== "https://snake.money/enter_room_free") {
            setMessage(`Регистрация на бесплатный турнир на 1450B откроется через ${formatTime(timeRemaining)}`)
        }
    }, [timeRemaining])

    return (
        <BrowserRouter>
            <Navbar />
            {Object.keys(store.messages).length > 0 && (
                <div className="containerSuccsesMessages">
                    {Object.keys(store.messages).map((key,index) => {
                        const value = store.messages[key];
                        
                        return (
                        

                        <value.type key={key} disappear={value.disappear} index={key} message={value.message}
                            onClose={() => store.delete_message(key)} />
                    )})}
                </div>
            )}
            {/*<button style={{position:"absolute",top:"50%",left:0,zIndex:"100000"}} onClick={()=>vibrateFunc()}>Testik</button>*/}
            {message && <Information message={message} onClose={() => setMessage("")} />}
            <div className={`${styles.MainContainer} ${((!store.visible_right_panel)) && styles.hiddenChat}`}>


                <Routes>

                    <Route path="/test" element={<Testik />} />
                    <Route path="/sapper" element={<Sapper/>}/>
                    <Route path="/tournaments" element={<Tournaments/>}/>
                    <Route path="/tournament/:id" element={<PageTour/>}/>
                    <Route path="/telegram_auth" element={<TelegramAuth/>}/>


                    <Route path="/auction" element={<Auction/>}/>
                    <Route path="/slots" element={<MainPageSlots category_games={"slots"} />} />
                    <Route path="/live_dealers" element={<MainPageSlots category_games={"LD"} />} />
                    <Route path="/simple_roulete" element={<SimpleRoulete />} />
                    
                    <Route path="/plinko" element={<Plinko />} />
                    <Route path="/botsFight" element={<BotsFight />} />
                    <Route path="/slot/:gameData" element={<PageGameSlot />} />
                    <Route path="/slot_game/:gameData" element={<PageGameSlot />} />
                    <Route path="/" element={<Main />} />
                    <Route path="/auth_google" element={<GoogleAuth />} />
                    <Route path="/page/:id" element={<PageInformation />} />
                    <Route path="/list_room_cost" element={<RoomList />} />
                    <Route path="/pay" element={<Deposit />} />
                    <Route path="/enter_room_free" element={<EnterRoom />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/*" element={<Navigate to="/" />} />
                </Routes>
            </div>
            <RightBar/>
           



            {modal_freespins.status && (
                <Modal Component={SuccsesFreeSpins} props={{
                    freespins: modal_freespins.freespins, text: modal_freespins.text, closeModel: () => {
                        setModal_freespins({ status: false, freespins: 0 })
                        store.set_modal(null)
                    }
                }} ModelState={modal_freespins.status}
                    setModelState={() => {
                        setModal_freespins({ status: false, freespins: 0 })
                        store.set_modal(null)

                    }} />
            )}

            <Modal type={"reg"} Component={RegForm} ModelState={modal_unReg.status}
                setModelState={() => {
                    setModal_unReg({ status: false })

                }} />
            <Modal type={"login"} Component={LoginForm} ModelState={modal_Login.status}
                setModelState={() => {
                    setModal_Login({ status: false })

                }} />


            <Modal Component={Promocode} type={"promocode"} props={{
                closeModal: () => {
                    setModal_promocode({ status: false })
                }
            }} ModelState={modal_promocode.status} setModelState={() => {
                setModal_promocode({ status: false })
            }} />

            {/*{modal_succses && (*/}


            {/*)}*/}


        </BrowserRouter>
    );
});

export default MainApp;